import React, { useEffect } from "react";
import "./styles.css";
import { connect } from "react-redux";
import { TOASTER_HIDE, toaster_s, toaster_e, toaster_w } from "../../constant";
import {
  HiOutlineCheckCircle,
  HiOutlineExclamationCircle,
  HiOutlineXCircle,
  HiOutlineX,
} from "react-icons/hi";

function getToastVariant(type) {
  if (type === toaster_s) {
    return "success";
  }
  if (type === toaster_e) {
    return "error";
  }
  if (type === toaster_w) {
    return "warning";
  }
  return "info";
}

function ToastIcon({ variant }) {
  const size = 20;

  if (variant === "success") {
    return <HiOutlineCheckCircle size={size} />;
  }
  if (variant === "error") {
    return <HiOutlineXCircle size={size} />;
  }
  if (variant === "warning") {
    return <HiOutlineExclamationCircle size={size} />;
  }
  return <HiOutlineExclamationCircle size={size} />;
}

const Toaster = (props) => {
  const { toaster, hideToaster } = props;
  const { show, type, heading, description, autoHide } = toaster;

  useEffect(() => {
    if (!show || !autoHide) {
      return undefined;
    }

    const timer = setTimeout(() => {
      hideToaster();
    }, 7000);

    return () => clearTimeout(timer);
  }, [show, autoHide, hideToaster]);

  if (!show) {
    return null;
  }

  const variant = getToastVariant(type);
  const items = Array.isArray(description)
    ? description.map((item) => String(item).trim()).filter(Boolean)
    : [];

  return (
    <div
      className={`pi-toast pi-toast--${variant}`}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <div className="pi-toast__icon" aria-hidden>
        <ToastIcon variant={variant} />
      </div>

      <div className="pi-toast__body">
        <p className="pi-toast__heading">{heading || variant}</p>
        {items.length === 1 ? (
          <p className="pi-toast__message">{items[0]}</p>
        ) : items.length > 1 ? (
          <div className="pi-toast__messages">
            {items.map((item, index) => (
              <p key={`${item}-${index}`} className="pi-toast__message">
                {item}
              </p>
            ))}
          </div>
        ) : null}
      </div>

      <button
        type="button"
        className="pi-toast__close"
        onClick={() => hideToaster()}
        aria-label="Dismiss notification"
      >
        <HiOutlineX size={18} />
      </button>
    </div>
  );
};

const mapStateToProps = (state) => ({
  toaster: state.toaster,
});

const mapDispatchToProps = (dispatch) => ({
  hideToaster: () =>
    dispatch({
      type: TOASTER_HIDE,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Toaster);
